<template>
  <div class="schoolPageMain">
    <el-tabs v-model="activeName">
      <el-tab-pane label="PC模板" name="1" style="background:#fff;">
        <div class="tempContainer">
          <div class="templateTop">
            <span class="tips">选择以下模板，快速体验网校（三选一）</span>
            <div class="searchTool">
              <!-- <el-select placeholder="请选择" v-model="choosedTemplate">
                <el-option v-for="item in tempOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-button type="primary">查询</el-button> -->
            </div>
          </div>
          <div class="chooseTempBox">
            <div class="tempItem" v-for="(item,index) in tempOptions" :key="index" @click="changeItemIndex(index)">
              <p>{{item.name}}</p>
              <img :src="item.remark" alt="">
              <div class="rowBet">
                <!-- <el-button type="default" v-if="item.defaultTheme">当前使用</el-button>
                <el-button type="primary" v-else @click="useThisTemp(item.id)">使用模板</el-button> -->
                <el-upload style="display:inline-block;" class="crm-upload" :action="fileObj.url" :before-upload="lbtbeforeUpload" :on-success="lbtSuccess" :headers="reqData" multiple :show-file-list="false">
                  <el-button icon="el-icon-plus">上传图片</el-button>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="PC网校设置" name="2" style="background:#fff;">
        <pcSetting />
      </el-tab-pane>
    </el-tabs>
    <!-- <pcSetting /> -->
  </div>
</template>
<script>
import pcSetting from "./pcSetting";
import { mapGetters } from "vuex";

export default {
  components: { pcSetting },
  data () {
    return {
      activeName: '1',
      choosedTemplate: '',
      clickedTemp: 0,
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      tempOptions: [],
      searchForm: {
        template: ''
      },
      domain: ''
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    }
  },
  watch: {

  },
  mounted () {

    // this.$router.push({ path: "/register96" });
    this.getTempDictionary(() => {

      this.api.schoolPage.getGeneralSettingDetail({}).then(result => {
        if (result.data) {
          this.domain = result.data.domain;
        }
      }).catch(error => {
        console.log(error);
      });
    })
  },

  methods: {
    lbtbeforeUpload (file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    changeItemIndex (index) {
      console.log(index)
      this.clickedTemp = index
    },
    lbtSuccess (res, file, fileList, val) {
      console.log(res.data)
      this.api.schoolPage.updateTempCover({ id: this.tempOptions[this.clickedTemp].id, remark: res.data }).then(res => {
        this.getTempDictionary()
      })
    },
    useThisTemp (id) {
      this.api.schoolPage.updateAgentTemp({ templateId: id }).then(res => {
        this.getTempDictionary()
        if (res.success) this.$message.success("操作成功")
      })
    },
    getTempDictionary (callback) {
      this.api.dictionary.getTempDictionaryData().then(result => {
        console.log(result)
        this.tempOptions = result.data
        this.choosedTemplate = result.data[0] ? result.data[0].id : ''
        callback && callback()
      }).catch(error => {
        console.log(error);
      });
    },
  },

}
</script>

<style lang="less">
.schoolPageMain {
  margin: 10px;
  padding: 10px;
  background-color: #fff;
  position: relative;
}
.viewPc {
  position: absolute !important;
  top: 25px;
  right: 12px;
}
.templateTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
.tempContainer {
  padding-bottom: 60px;
}
.chooseTempBox {
  display: flex;
  flex-direction: row;
  padding: 0 127px;
  justify-content: space-around;
  .tempItem {
    display: flex;
    flex-direction: column;
    align-content: center;
    p {
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      margin-bottom: 10px;
    }
    img {
      width: 300px;
      height: 300px;
    }
    .el-button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/schoolPage/index.vue